import React from 'react';

import style from './Grid.scss';

export enum GridVariant {
  variableWidth = '',
  fixedWidth = 'FixedWidth'
}
export interface Props {
  children: React.ReactNode[];
  variant?: GridVariant;
}

const Grid: React.FC<Props> = ({ variant = GridVariant.variableWidth, children }) => {
  if (!children) {
    return null;
  }
  return (
    <div className={`${style.grid} ${style[variant as unknown as keyof typeof style]}`}>
      {children.map((child, i) => (
        <div key={i} className={style.gridItem}>
          {child}
        </div>
      ))}
    </div>
  );
};
export default Grid;
